import { useState, type CSSProperties } from "react";

const BRANDS: { name: string; slug: string; glyph: string; bg: string; fg: string; iconColor: string }[] = [
  { name: "QuickBooks", slug: "quickbooks",  glyph: "qb", bg: "#2CA01C", fg: "#FFFFFF", iconColor: "ffffff" },
  { name: "Xero",       slug: "xero",        glyph: "⭘",  bg: "#13B5EA", fg: "#FFFFFF", iconColor: "ffffff" },
  { name: "Stripe",     slug: "stripe",      glyph: "S",  bg: "#635BFF", fg: "#FFFFFF", iconColor: "ffffff" },
  { name: "Plaid",      slug: "plaid",       glyph: "P",  bg: "#111111", fg: "#FFFFFF", iconColor: "ffffff" },
  { name: "Slack",      slug: "slack",       glyph: "#",  bg: "#4A154B", fg: "#FFFFFF", iconColor: "ffffff" },
  { name: "Gmail",      slug: "googlegmail", glyph: "✉",  bg: "#FFFFFF", fg: "#202124", iconColor: "EA4335" },
];

export function BrandChips({ className }: { className?: string }) {
  return (
    <div className={className}>
      <div className="flex flex-wrap justify-center items-center gap-2.5">
        {BRANDS.map((b) => (
          <Chip key={b.name} {...b} />
        ))}
      </div>
    </div>
  );
}

function Chip({ name, slug, glyph, bg, fg, iconColor }: (typeof BRANDS)[number]) {
  const [imgFailed, setImgFailed] = useState(false);
  const isWhite = bg === "#FFFFFF";
  const style: CSSProperties = {
    backgroundColor: bg,
    color: fg,
    border: isWhite ? "1px solid var(--ink-200)" : undefined,
  };
  return (
    <div
      className="inline-flex items-center gap-2 h-9 px-3 rounded-full text-[13px] font-semibold tracking-tight"
      style={style}
    >
      <span
        className="inline-flex items-center justify-center w-5 h-5 rounded-full shrink-0 text-[10px] font-bold"
        style={{ backgroundColor: isWhite ? "var(--ink-100)" : "rgba(255,255,255,0.18)", color: fg }}
        aria-hidden="true"
      >
        {imgFailed ? (
          glyph
        ) : (
          <img
            src={`https://cdn.simpleicons.org/${slug}/${iconColor}`}
            alt=""
            width={12}
            height={12}
            loading="lazy"
            onError={() => setImgFailed(true)}
          />
        )}
      </span>
      {name}
    </div>
  );
}
